import React from "react";

import { Table, Row } from 'react-native-table-component';
import { View, StyleSheet, Text, Dimensions } from "react-native";


const ReportsTable = ({tableHead, widthArr, reports,  selectedIndex, stateReports}) => {

    const tableWidth = Dimensions.get('window').width * 0.2;

    const data = (vehicleInfo) => {
        if(selectedIndex===0){
            return[
                vehicleInfo.runningDate,
                vehicleInfo.runningTime,
                vehicleInfo.nickName,
                vehicleInfo.combineStr,
                vehicleInfo.totalMileage
            ]
        }else if(selectedIndex===1){
            return[
                vehicleInfo.Num, 
                vehicleInfo.startHHMMSS, 
                vehicleInfo.leaveHHMMSS, 
                vehicleInfo.stopTime, 
                vehicleInfo.engineOn, 
                vehicleInfo.address,
            ]
        }else if(selectedIndex===2){
            return[
                vehicleInfo.Num,
                vehicleInfo.dateYYMMDD, 
                vehicleInfo.startHHMMSS, 
                vehicleInfo.leaveHHMMSS, 
                vehicleInfo.stopTime, 
                vehicleInfo.engineOn, 
                vehicleInfo.address,
            ]
        }
    }

    return(
        <View>
            <Text style={styles.tableTitle}>Daily Report</Text>
            <Table borderStyle={{borderWidth: 1, borderColor: '#EF9A19',marginTop:'10'}}>
                <Row data={tableHead} widthArr={widthArr}  textStyle={styles.text}/>
            </Table>
            <View style={styles.wrapper}>
                <Table borderStyle={{borderWidth: 1, borderColor: '#EF9A19'}}>
                {
                    reports.map(
                        (vehicelInfo, index) => (
                        <Row
                            key={index}
                            data={data(vehicelInfo)}
                            widthArr={widthArr}
                            textStyle={styles.text}
                        />
                    ))
                }
                </Table> 
            </View>

            {selectedIndex===0 && (
                <View style={{marginTop: 50}}>
                    <Text style={[styles.tableTitle]}>States Report</Text>
                    <View style={[styles.wrapper, {width: tableWidth, paddingBottom: 20}]}>
                            <Table borderStyle={{borderWidth: 1, borderColor: '#EF9A19'}}>
                            {
                                stateReports.map(
                                    (vehicelInfo, index) => (
                                    <Row
                                        key={index}
                                        data={[
                                            vehicelInfo.location,
                                            vehicelInfo.stateMileage,
                                        ]}
                                        widthArr={['50%', '50%']}
                                
                                        textStyle={styles.text}
                                    />
                                ))
                            }
                            </Table>    
                    </View>
                </View>
            )}
        </View>
        
    )
}

const styles = StyleSheet.create({
    text: { 
        margin: 6,
        textAlign: 'center'
    },
    tableTitle: {
        color: 'white',
        backgroundColor: 'rgba(0, 122, 255, 0.8)',
        fontSize: 12,
        padding: 5,
        width: 100,
    },
    loading: { 
        margin: 10,
        textAlign: 'center',
        fontSize: 50,
        opacity: 0.5,
    },
    wrapper: { 
        marginTop: -1,
    },
})

export default ReportsTable;